import React, { useEffect, useMemo } from 'react';
import styled, { css } from 'styled-components';
import {
	createRecordPathCodec,
	NavbarType,
	QuickbaseIFrameContainer,
	quickbaseNavbarStoreSelector,
	recordPathSegmentFor,
	recordPresentationFor,
	useQuickbaseHostBridgeSync,
	useUtilitiesStore,
} from '@warehouse/quickbase';
import Card from '../../components/library/Card';

export function UtilitiesQuickbase() {
	const isLoading = useUtilitiesStore(quickbaseNavbarStoreSelector.isLoading);
	const isAuthenticated = useUtilitiesStore(quickbaseNavbarStoreSelector.isAuthenticated);
	const error = useUtilitiesStore(quickbaseNavbarStoreSelector.error);
	const embedUrl = useUtilitiesStore(quickbaseNavbarStoreSelector.embedUrl);
	const frameUrl = useUtilitiesStore(quickbaseNavbarStoreSelector.frameUrl);
	const showAuthOverlay = useUtilitiesStore(quickbaseNavbarStoreSelector.showAuthOverlay);
	const authFlow = useUtilitiesStore(quickbaseNavbarStoreSelector.authFlow);
	const actions = useUtilitiesStore(quickbaseNavbarStoreSelector.actions);
	const { loadEmbedUrl, authenticate, setShowAuthOverlay, dismissAuthOverlay, recoverSession } = actions;

	const codec = useMemo(
		() =>
			createRecordPathCodec({
				resolveBasePath: () => '/utilities',
				recordSegment: recordPathSegmentFor(NavbarType.Utilities),
			}),
		[],
	);

	const { bridge, initialEmbedParams, reloadToken } = useQuickbaseHostBridgeSync({
		embedUrl,
		codec,
		reloadEmbedUrl: loadEmbedUrl,
		presentation: recordPresentationFor(NavbarType.Utilities),
	});

	useEffect(() => {
		loadEmbedUrl(initialEmbedParams);
	}, [loadEmbedUrl, initialEmbedParams]);

	return (
		<Wrapper>
			<CardWrapper>
				<Card sx={{ minWidth: 275, overflow: 'hidden', height: '100%' }}>
					<QuickbaseIFrameContainer
						isLoading={isLoading}
						isAuthenticated={isAuthenticated}
						error={error}
						embedUrl={embedUrl}
						frameUrl={frameUrl}
						showAuthOverlay={showAuthOverlay}
						authenticate={authenticate}
						setShowAuthOverlay={setShowAuthOverlay}
						dismissAuthOverlay={dismissAuthOverlay}
						recoverSession={recoverSession}
						authFlow={authFlow}
						iFrameType="Utilities"
						bridge={bridge}
						reloadToken={reloadToken}
					/>
				</Card>
			</CardWrapper>
		</Wrapper>
	);
}

// Styled components
const Wrapper = styled.div(
	() => css`
		background-color: #dde0e3;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		width: 100%;
	`,
);

const CardWrapper = styled.div(
	({ theme }) => css`
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		gap: ${theme.spacing(2)};
		padding: ${theme.spacing(2)};
		width: 100%;
	`,
);
